export default __webpack_public_path__ + "media/images/promare/promare2-b9619906084c0b36fea6f1010117a6e4.jpg";